// Chart.js plugin that draws a vertical line at a label index provided via options (label is numeric ms)
import { Chart } from 'chart.js';

interface VlinePluginOptions {
  label?: string | number;
  color?: string;
  width?: number;
}

/**
 * Finds the closest label index to the target value
 */
function findClosestLabelIndex(labels: unknown[], target: number): number {
  let bestIdx = -1;
  let bestDiff = Infinity;

  for (let i = 0; i < labels.length; i++) {
    const lv = labels[i];
    const n =
      typeof lv === 'string' && !isNaN(Number(lv))
        ? Number(lv)
        : typeof lv === 'number'
          ? lv
          : null;
    if (typeof n !== 'number' || isNaN(n)) continue;

    const diff = Math.abs(n - target);
    if (diff < bestDiff) {
      bestDiff = diff;
      bestIdx = i;
    }
  }

  return bestIdx;
}

const vlinePlugin = {
  id: 'vlinePlugin',
  afterDraw: (chart: Chart, _args: Record<string, unknown>, options: VlinePluginOptions) => {
    const pluginOptions = (chart.options?.plugins as any)?.vlinePlugin as
      VlinePluginOptions | undefined;
    const label = pluginOptions?.label;
    if (label === undefined || label === null) return;

    const labels = chart.data?.labels || [];
    const target = typeof label === 'string' && !isNaN(Number(label)) ? Number(label) : label;

    // Find exact match or closest match
    let index = labels.findIndex((l: unknown) => l === target);
    if (index === -1) {
      index = findClosestLabelIndex(labels, target as number);
    }

    if (index === -1) return;

    const ctx = chart.ctx;
    const xScale = chart.scales['x'];
    if (!xScale) return;

    const x = xScale.getPixelForValue
      ? xScale.getPixelForValue(labels[index] as unknown as number)
      : null;
    if (x === null) return;

    // Draw vertical dashed line
    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([6, 6]);
    ctx.strokeStyle = options?.color || 'red';
    ctx.lineWidth = options?.width || 2;
    ctx.moveTo(x, chart.chartArea.top);
    ctx.lineTo(x, chart.chartArea.bottom);
    ctx.stroke();
    ctx.restore();
  },
};

export default vlinePlugin;
